/** Wire contract: the `/api/v1` unmatched-route marker, read by the npm CLI. */
export const PATH_NOT_SERVED = "path_not_served";
